import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

export const LANGUAGE_COOKIE = "gito-lang";
export const SUPPORTED_LANGUAGES = [
    { code: "en", labelKey: "language.en" },
    { code: "sv", labelKey: "language.sv" },
];

const localeLoaders = {
    en: () => import("./locales/en.json"),
    sv: () => import("./locales/sv.json"),
};

const resolveSupportedLanguage = (lng) =>
    (lng || "en").toLowerCase().startsWith("sv") ? "sv" : "en";

const localeBackend = {
    type: "backend",
    init() {},
    read(language, _namespace, callback) {
        const loader = localeLoaders[resolveSupportedLanguage(language)];
        loader()
            .then((mod) => callback(null, mod.default ?? mod))
            .catch((err) => callback(err, false));
    },
};

const setDocumentLang = (lng) => {
    const language = resolveSupportedLanguage(lng);
    if (typeof document !== "undefined") {
        document.documentElement.lang = language;
    }
};

export const i18nReady = i18n
    .use(localeBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en",
        supportedLngs: ["en", "sv"],
        nonExplicitSupportedLngs: true,
        load: "languageOnly",
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
        detection: {
            order: ["cookie"],
            caches: ["cookie"],
            lookupCookie: LANGUAGE_COOKIE,
            cookieMinutes: 60 * 24 * 365,
            cookieOptions: {
                path: "/",
                sameSite: "lax",
            },
        },
    })
    .then(() => {
        setDocumentLang(i18n.resolvedLanguage || i18n.language);
    });

i18n.on("languageChanged", setDocumentLang);

export default i18n;
